import React, {useMemo, useState} from 'react'
import { FormInputComponent } from "../../../components/form/Form";
import { useSupplierFormItem } from "../providers/SupplierFormItemProvider";
import { Divider, Select } from "antd";

const { Option } = Select;

const levels = [
    { label: 'Select a partner provider...', value: '', disabled: true },
    { label: 'Entry', value: 1 },
    { label: 'Mid Tier', value: 5 },
    { label: 'Top Tier', value: 10 }
];

const SupplierPartnerProgramsForm = () => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
    } = useSupplierFormItem()

    const [showProviderDropdown, setShowProviderDropdown] = useState(false);


    const partnerCategories = laravel?.partner_program_categories || [];


    const handleProviderSelect = (programId) => {
        let selectedProgram = null;
        let selectedCategory = null;

        partnerCategories.forEach(category => {
            const program = category.programs.find(p => p.id === programId);
            if (program) {
                selectedProgram = program;
                selectedCategory = category;
            }
        });

        if (selectedProgram && selectedCategory) {
            onModelChange({
                ...profileItem,
                program_id: selectedProgram.id,
                category_id: selectedCategory.id,
                provider_name: selectedProgram.name
            });
        }
    };

    return (
        <div className="flex flex-col">
            <div className="field-section flex-row" style={styles.fieldSection}>
                <div className="field px-3.5 basis-6/12">
                    <div className="form-group">
                        <label className="col-form-label">
                            Partner Provider *
                        </label>
                        <Select
                            value={profileItem.program_id}
                            onChange={handleProviderSelect}
                            placeholder="Select a partner provider..."
                            style={{ width: '100%', height: '45px' }}
                            showSearch
                            filterOption={(input, option) =>
                                option.children?.toLowerCase?.().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {partnerCategories.map((category) => (
                                <Select.OptGroup key={category.id} label={category.name}>
                                    {category.programs.map((provider) => (
                                        <Option key={provider.id} value={provider.id}>
                                            {provider.name}
                                        </Option>
                                    ))}
                                </Select.OptGroup>
                            ))}
                        </Select>
                    </div>
                </div>
                <div className="field px-3.5 basis-6/12">
                    <FormInputComponent
                        fieldName="level"
                        value={profileItem.level}
                        label="Partnership Level"
                        placeholder="Select level..."
                        type={'select'}
                        required={true}
                        options={levels}
                        style={styles.field}
                        className="flex flex-col"
                    />
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <FormInputComponent
                        fieldName="title"
                        value={profileItem.title}
                        type={'text'}
                        label="Partnership Title"
                        maxLength={255}
                        required={true}
                        placeholder="e.g., Platinum Partner, Premier Partner"
                        style={styles.field}
                        className="flex flex-col"
                    />
                </div>
            </div>

            <div className="field-section flex-row items-start">
                <div className="field px-3.5 basis-6/12">
                    <FormInputComponent
                        fieldName="started_at"
                        value={profileItem.started_at}
                        placeholder="--/--/----"
                        type={'date'}
                        label="Partnership Start Date"
                        required={true}
                        style={styles.field}
                        className="flex flex-col"
                    />
                </div>
                <div className="field px-3.5 basis-6/12 [&>.form-group]:flex [&>.form-group]:flex-col">
                    <FormInputComponent
                        fieldName="vertical_focus"
                        value={profileItem.vertical_focus}
                        type={'text'}
                        label="Vertical Focus"
                        maxLength={255}
                        required={false}
                        placeholder="e.g., Cloud Services, E-commerce, Healthcare"
                        style={styles.field}
                        className="flex flex-col"
                    />
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field-element py-0">
                    <Divider className="mt-1 mb-2" />
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <FormInputComponent
                        fieldName="marketplace_url"
                        value={profileItem.marketplace_url}
                        type={'url'}
                        label="Marketplace URL"
                        required={false}
                        placeholder="https://partners.example.com/your-agency"
                        style={styles.field}
                        className="flex flex-col"
                    />
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field px-3.5 basis-6/12">
                    <FormInputComponent
                        fieldName="total_certifications"
                        value={profileItem.total_certifications}
                        type={'number'}
                        label="Total Certifications Across Members"
                        required={false}
                        placeholder="12"
                        min={0}
                        style={styles.field}
                        className="flex flex-col"
                    />
                </div>
            </div>

            {profileItem.program_id && profileItem.title && (
                <React.Fragment>
                    <h3 className="font-semibold text-gray-900 mb-2 text-lg">Preview:</h3>
                    <div className="field-section flex-row">
                        <div className="field px-3.5 basis-10/12">
                            <PartnerProgramCard profileItem={profileItem} />

                            {/* <div className="mt-6 p-6 bg-gray-50 rounded-lg border-l-4 border-blue-500">
                                <div className="space-y-3">

                                    <p className="text-gray-700 text-base">
                                        <span className="font-semibold text-gray-900 text-lg">{profileItem.name} - </span>
                                        {profileItem.title && ` ${profileItem.title}`}
                                        {!!profileItem.level && ` (Level ${TB.find(levels, ['value', parseInt(profileItem.level)])?.label})`}
                                        {TB.moment(profileItem.started_at)?.isValid() && ` since ${TB.moment(profileItem.started_at).format('ll')}`}
                                    </p>
                                    <div className="flex flex-wrap gap-6 text-sm text-gray-600">
                                        {profileItem.vertical_focus && (
                                            <span>Focus: {profileItem.vertical_focus}</span>
                                        )}
                                        {profileItem.total_certifications && (
                                            <span>Certifications: {profileItem.total_certifications}</span>
                                        )}
                                        {profileItem.marketplace_url && (
                                            <a
                                                href={profileItem.marketplace_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-600 hover:text-blue-800 underline"
                                            >
                                                View Marketplace Profile
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    )
}

export default SupplierPartnerProgramsForm;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
        display: 'flex',
        flexDirection: 'column',
    },
};

export const PartnerProgramCard = ({ profileItem }) => {
    const partnerCategories = laravel?.partner_program_categories || [];

    const partnerCategory = useMemo(() => {
        return TB.find(partnerCategories, ['id', profileItem.category_id]);
    }, [profileItem]);
    const selectedProgram = useMemo(() => {
        return TB.find(partnerCategory?.programs || [], ['id', profileItem.program_id]);
    }, [partnerCategory]);
    return (
        <div className="mt6 p-6 bg-gray-50 rounded-lg border-l-4 border-blue-500">
            <div className="space-y-3">

                <p className="text-gray-700 text-base">
                    {/*<i className={"text-lg " + TB.find(partnerPlatformsIcons, ['name', profileItem.name])?.icon}></i>*/}
                    <span className="font-semibold text-gray-900 text-lg">{profileItem.provider_name || profileItem.name} - </span>
                    {profileItem.title && ` ${profileItem.title}`}
                    {!!profileItem.level && ` (Level ${TB.find(levels, ['value', parseInt(profileItem.level)])?.label})`}
                    {TB.moment(profileItem.started_at)?.isValid() && ` since ${TB.moment(profileItem.started_at).format('ll')}`}
                </p>
                <div className="flex flex-wrap gap-6 text-sm text-gray-600">
                    {profileItem.vertical_focus && (
                        <span>Focus: {profileItem.vertical_focus}</span>
                    )}
                    {profileItem.total_certifications && (
                        <span>Certifications: {profileItem.total_certifications}</span>
                    )}
                    {profileItem.marketplace_url && (
                        <a
                            href={profileItem.marketplace_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            View Marketplace Profile
                        </a>
                    )}
                </div>
            </div>
        </div>
    )
}